import React, { ChangeEventHandler, ReactEventHandler } from 'react';

export function formatPhone(s: string) {
    if (s.length == 10) {
        return "(" + s.substring(0, 3) + ") " + s.substring(3, 6) + "-" + s.substring(6);
    }
    return s;
}

export function formatFormPhone(s: string) {
    if (s && s.length == 10) {
        s = s.substring(0, 3) + "-" + s.substring(3, 6) + "-" + s.substring(6);
        return s;
    }
    return s;
}

const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export function getDayOfWeek(d: Date) {
    return daysOfWeek[d.getUTCDay()];
}

const fullDaysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export function getFullDayOfWeek(d: Date) {
    return fullDaysOfWeek[d.getDay()];
}


//export const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function getMonth(d: string) {
    return months[parseInt(d.substring(5, 7)) - 1];
}

const fullMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export function getFullMonth(d: string) {
    return fullMonths[parseInt(d.substring(5, 7)) - 1];
}

export function getDay(d: string) {
    return parseInt(d.substring(8, 10));
}

export function formatDate(d: Date) {
    var d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    d.setUTCHours(12, 0, 0, 0);
    return d.toISOString().split("T")[0];
}

export function formatNextAvailable(d: Date) {
    return getDayOfWeek(d) + ", " + getMonth(d.toISOString()) + " " + (d.getUTCDate())
}

export function formatTime(s: string, html?: boolean) {
    var d = new Date(s);
    return internalFormatTime(d, html);
}

function internalFormatTime(d: Date, html?: boolean) {    
    var h = d.getHours();
    var m = d.getMinutes();
    var ap = h >= 12 ? "PM" : "AM";
    h = h % 12;
    var hh = h == 0 ? "12" : "" + h;
    var mm = "" + m;
    if (m < 10) {
        mm = "0" + m;
    }
    if (html) {
        return <>{hh + ":" + mm}{<small>{ap}</small>}</>;
    } else {
        return hh + ":" + mm + " " + ap;
    }
}

export function formatLongDateTime(d: Date) {
    return getFullDayOfWeek(d) + ", " + getFullMonth(d.toISOString()) + " " + (d.getDate()) + ", " + (d.getFullYear()) + " at " + internalFormatTime(d);
}

export function getHours() {
    var h = [];

    for (let i = (window as any).SCHEDULE_START_HOUR; i <= (window as any).SCHEDULE_END_HOUR; i++) {
        var hs = "";
        if (i >= 12) {
            if (i > 12) {
                hs += (i - 12);
            } else {
                hs += "12";
            }
            hs += '\xa0' + "PM"
        } else {
            hs += i + '\xa0' + "AM"
        }
        h.push([i, hs]);
    }
    return h;
}

export function addDays(date, days) {
    var result = new Date(date);
    result.setUTCHours(12, 0, 0, 0);
    result.setUTCDate(result.getUTCDate() + days);
    return result;
}

export function $val(id) {
    return (document.getElementById(id) as HTMLInputElement).value;
}

export function $setVal(id, value) {
    (document.getElementById(id) as HTMLInputElement).value = value;
}

export function $checked(id) {
    return (document.getElementById(id) as HTMLInputElement).checked;
}

export function $text(id: string) {
    return (document.getElementById(id) as HTMLElement).innerText;
}

export function $setText(id: string, value: string) {
    (document.getElementById(id) as HTMLElement).innerText = value;
}

export function $disable(id: string) {
    (document.getElementById(id) as any).disabled = true;
}

export function $enable(id: string) {
    (document.getElementById(id) as any).disabled = false;
}

export function getAftHeader() {
    return {
        headers: {
            "RequestVerificationToken": document.forms["aft"]["__RequestVerificationToken"].value,
            "Content-Type": "application/json"
        }
    }
}

function formatDateField(s: string) {
    let cleanDate = '';
    for (let i = 0; i < s.length && cleanDate.length < 8; i++) {
        if (s[i] >= '0' && s[i] <= '9') {
            cleanDate += s[i];
        }
    }

    s = cleanDate;

    if (s.length >= 4) {
        s = s.substring(0, 2) + '/' + s.substring(2, 4) + '/' + s.substring(4, s.length);
    } else if (s.length >= 2) {
        s = s.substring(0, 2) + '/' + s.substring(2, s.length);
    }

    return s;
}

export const onChangeDateFormatter = (e: React.ChangeEvent<HTMLInputElement>) => { e.currentTarget.value = formatDateField(e.currentTarget.value) };

function formatPhoneField(s: string) {
    let cleanPhone = '';
    for (let i = 0; i < s.length && cleanPhone.length < 10; i++) {
        if (s[i] >= '0' && s[i] <= '9') {
            cleanPhone += s[i];
        }
    }

    s = cleanPhone;

    if (s.length >= 7) {
        s = s.substring(0, 3) + '-' + s.substring(3, 6) + '-' + s.substring(6, s.length);
    } else if (s.length >= 4) {
        s = s.substring(0, 3) + '-' + s.substring(3, s.length);
    }

    return s;
}

export const onChangePhoneFormatter = (e: React.ChangeEvent<HTMLInputElement>) => { e.currentTarget.value = formatPhoneField(e.currentTarget.value) };

function formatZipField(s: string) {
    let cleanZip = '';
    for (let i = 0; i < s.length && cleanZip.length < 9; i++) {
        if (s[i] >= '0' && s[i] <= '9') {
            cleanZip += s[i];
        }
    }

    s = cleanZip;

    if (s.length >= 6) {
        s = s.substring(0, 5) + '-' + s.substring(5, s.length);
    }

    return s;
}

export const onChangeZipFormatter = (e: React.ChangeEvent<HTMLInputElement>) => { e.currentTarget.value = formatZipField(e.currentTarget.value) };

export function addQueryParam(name: string, value: any): string[] {
    if (value == null) return [];
    if (Array.isArray(value)) {
        return value
            .filter(v => v != null && v !== '')
            .map(v => `${encodeURIComponent(name)}=${encodeURIComponent(v)}`);
    }
    if (value === '') return [];
    return [`${encodeURIComponent(name)}=${encodeURIComponent(value)}`];
}

export function useSearchParams(names: string[]) {
    let params = new URLSearchParams(window.location.search);
    return names.map(n => params.get(n));
}

export function redirectToError(search: string, error: string) {    
    window.location.href = `./contactprovider${search}&error=${encodeURIComponent(error)}`;
}

export function handleInverseRegexInput(e, setter: Function, regex: string|RegExp) {
    if (e.target.value.match(regex) == null) {
        setter(e.target.value);
    }
}

export function handleRegexInput(e, setter: Function, regex: RegExp) {
    if (e.target.value.match(regex) != null) {
        setter(e.target.value);
    }
}